import { SaveVersion, GetVersionMachine, GetVersionList, GetSoftwareList, GetMachineListData } from '@/api/version'
export default {
  state: {},
  actions: {
    SaveVersion ({ commit }, payload) {
      return new Promise(resolve => {
        SaveVersion(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetVersionMachine ({ commit }, payload) {
      return new Promise(resolve => {
        GetVersionMachine(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetVersionList ({ commit }, payload) {
      return new Promise(resolve => {
        GetVersionList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetSoftwareList ({ commit }, payload) {
      return new Promise(resolve => {
        GetSoftwareList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineListData ({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineListData(payload).then(res => {
          resolve(res.data)
        })
      })
    }
  },
  getters: {},
  mutations: {}
}
